export default __webpack_public_path__ + "static/media/icons.9724ca75.svg";